"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var select_1 = require("@material/select");
var globalCss = require("./global.scss");
var dom_ready_1 = require("../util/dom-ready");
// @ts-ignore
var util_ts_1 = require("../util.ts");
//@ts-ignore
require("../theme.ts");
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select.prototype.installed = function () {
        var _this = this;
        if (this.props.menu) {
            var style = document.createElement('style');
            style.textContent = globalCss;
            document.querySelector('head').appendChild(style);
        }
        var select = new select_1.MDCSelect(this.shadowRoot.querySelector('.mdc-select'));
        select.listen('MDCSelect:change', function () {
            _this.fire('change', {
                selectedIndex: select.selectedIndex,
                value: select.value
            });
        });
        dom_ready_1.domReady(function () {
            _this.update();
        });
    };
    Select.prototype.render = function (props) {
        if (props.menu) {
            return (omi_1.h("div", { class: "mdc-select" },
                omi_1.h("input", { type: "hidden", name: "enhanced-select" }),
                omi_1.h("i", { class: "mdc-select__dropdown-icon" }),
                omi_1.h("div", { class: "mdc-select__selected-text" }),
                omi_1.h("div", { class: "mdc-select__menu mdc-menu mdc-menu-surface" },
                    omi_1.h("ul", { class: "mdc-list" }, props.menu.map(function (item) { return omi_1.h("li", { class: "mdc-list-item", "data-value": item.value }, item.text); }))),
                omi_1.h("label", { class: "mdc-floating-label" }, props.label),
                omi_1.h("div", { class: "mdc-line-ripple" })));
        }
        return (omi_1.h("div", { class: "mdc-select" },
            omi_1.h("i", { class: "mdc-select__dropdown-icon" }),
            omi_1.h("select", { class: "mdc-select__native-control" }, this.normalizedNodeName ? props.children : util_ts_1.htmlToVdom(this.innerHTML)),
            omi_1.h("label", { class: "mdc-floating-label" }, props.label),
            omi_1.h("div", { class: "mdc-line-ripple" })));
    };
    Select.css = css;
    Select.propTypes = {
        label: String,
        menu: Object
    };
    Select = __decorate([
        omi_1.tag('m-select')
    ], Select);
    return Select;
}(omi_1.WeElement));
exports.default = Select;
